import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import {
  DynamicFormConfigResponse,
  DynamicFormSubmissionResponse,
  DynamicFormUploadResponse,
  DynamicFormStripeProduct,
} from '../interfaces/dynamic-form';

const REQUEST_TIMEOUT = 30000;

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService {
  private http = inject(HttpClient);

  getFormConfig(eventoSlug: string): Observable<DynamicFormConfigResponse> {
    return this.http
      .get<DynamicFormConfigResponse>(
        `${environment.apiUrl}/form-config/${eventoSlug}`
      )
      .pipe(timeout(REQUEST_TIMEOUT));
  }

  submitRegistration(
    formId: string,
    eventoId: string,
    dati: Record<string, unknown>,
    allegati?: { nomeCampo: string; documentoId: string }[]
  ): Observable<DynamicFormSubmissionResponse> {
    return this.http
      .post<DynamicFormSubmissionResponse>(
        `${environment.apiUrl}/iscrizioni-dinamiche`,
        { formId, eventoId, dati, allegati }
      )
      .pipe(timeout(REQUEST_TIMEOUT));
  }

  uploadFile(
    file: File,
    nomeCampo: string,
    eventoId: string,
    tipiAccettati?: string[],
    dimensioneMassimaBytes?: number
  ): Observable<DynamicFormUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('nomeCampo', nomeCampo);
    formData.append('eventoId', eventoId);
    if (tipiAccettati) {
      formData.append('tipiAccettati', tipiAccettati.join(','));
    }
    if (dimensioneMassimaBytes) {
      formData.append('dimensioneMassimaBytes', String(dimensioneMassimaBytes));
    }

    return this.http
      .post<DynamicFormUploadResponse>(
        `${environment.apiUrl}/iscrizioni-dinamiche/upload`,
        formData
      )
      .pipe(timeout(REQUEST_TIMEOUT));
  }

  getStripeProducts(
    tag: string,
    value: string,
    categoria?: string
  ): Observable<{ success: boolean; products: DynamicFormStripeProduct[] }> {
    let url = `${environment.apiUrl}/stripe/products-by-metadata?tag=${encodeURIComponent(tag)}&value=${encodeURIComponent(value)}`;
    if (categoria) {
      url += `&categoria=${encodeURIComponent(categoria)}`;
    }
    return this.http
      .get<{ success: boolean; products: DynamicFormStripeProduct[] }>(url)
      .pipe(timeout(REQUEST_TIMEOUT));
  }

}
